export const PUBLIC_OFFER = Object.freeze({ path: '/public/offer', snapshotId: 'neoprof-public-offer' });

export const PUBLIC_OFFER_COPY = Object.freeze({
  unavailable: 'Offre indisponible.',
  // Public pages say TTC; the art. 293 B mention stays in legal pages and invoices only.
  taxIncluded: 'TTC',
  pricesTaxIncluded: 'Prix TTC',
  neutralCta: 'Créer mon espace',
  neutralTrial: 'Sans carte bancaire',
  neutralMonths: 'Essai Pro',
  neutralFree: 'Essai gratuit',
  pendingPrice: 'Tarif à consulter',
  neutralPricingTitle: 'Essaie NeoProf avec tes cours.',
  trialRecap: 'Pendant ton essai :',
  annual: 'Annuel',
  monthly: 'Mensuel',
  trialMonths: (months) => `${months} mois`,
  offered: (months) => `${months} mois offert${months > 1 ? 's' : ''}`,
  free: (months) => `${months} mois gratuit${months > 1 ? 's' : ''}`,
  afterTrial: (monthly) => `Sans carte bancaire · puis ${monthly} / mois · sans engagement`,
  priceAfterTrial: (monthly) => `puis ${monthly} / mois · sans carte`,
  pickerPrice: (monthly) => `${monthly}/mois`,
  registerTrial: (months) => `Essai gratuit de ${months} illimité`,
  registerAfterTrial: (monthly) => `, puis ${monthly}/mois. Sans engagement.`,
  pricingTitle: (months, monthly) => `${months} pour tout essayer. Puis ${monthly} par mois.`,
  annualTerms: 'Sans engagement. Ou {yearly}/an.',
  legalTrial: (months) => `Les comptes créés bénéficient de ${months} d’essai Pro sans carte bancaire.`,
  neutralLegalTrial: 'Un essai Pro sans carte bancaire est proposé à la création du compte.',
  cta: (months) => `Commencer — ${months} mois offert${months > 1 ? 's' : ''}`,
  trial: (months) => `${months} mois offert${months > 1 ? 's' : ''} · sans carte bancaire`,
});
